module.exports = __webpack_public_path__ + "static/letters-people-72c9ef80a505698d58d1964c8bc31860.svg";